
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/rfp/done",
      function () {
        return require("private-next-pages/download/rfp/done/index.tsx");
      }
    ]);
  